package srializable

import apps.App
import apps.AppReport
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass
import kotlinx.serialization.protobuf.ProtoBuf

val JSON_INSTANCE by lazy {
    Json {
        ignoreUnknownKeys = true
        coerceInputValues = true
        encodeDefaults = true
        prettyPrint = false
        isLenient = true
        classDiscriminator = "polymorphic"
        serializersModule = SerializersModule {
            polymorphic(App::class) {
                subclass(App.None::class)
                subclass(App.Wheel::class)
                subclass(App.Image::class)
                subclass(App.Video::class)
                subclass(App.Pdf::class)
                subclass(App.WwwLink::class)
                subclass(App.WwwEmbedded::class)
                subclass(App.Rss::class)
                subclass(App.Balloon::class)
                subclass(App.Quiz::class)
                subclass(App.Gallery::class)
                subclass(App.VideoAlphaLoop::class)
                subclass(App.Maze::class)
            }
            polymorphic(App.Gallery.Media::class) {
                subclass(App.Gallery.Media.Image::class)
                subclass(App.Gallery.Media.Video::class)
            }
            polymorphic(AppReport::class) {
                subclass(AppReport.Quiz::class)
            }
        }
    }
}

@OptIn(ExperimentalSerializationApi::class)
val PROTO_INSTANCE by lazy {
    ProtoBuf {
        encodeDefaults = true
    }
}
